import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { AudioContext } from 'standardized-audio-context';
import ADSRView from './ADSRView';
import Choir from './Choir';
import { BACKGROUND_COLOR, COLOR_B } from './CONSTANTS';
import EchoNode from './EchoNode';
import EchoView from './EchoView';
import FilterView from './FilterView';
import Keyboard from './Keyboard';
import KeyConfigView from './KeyConfigView';
import Looper from './Looper';
import LooperView from './LooperView';
import OTView from './OTView';
import PostFilter from './PostFilter';
import SourceLooper from './SourceLooper';
import SourceLoopView from './SourceLoopView';
import SourceView from './SourceView';
import TouchSlider from './TouchSlider';
import { RemoveScroll } from 'react-remove-scroll';

//TODO: GROUP DEFAULT PARAMETERS IN ONE GIANT OBJECT (THAT CAN BE SAVED TO LOCAL STORAGE)

const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

class Synth extends React.Component {
	constructor(props) {
		super(props);
		this.filters = 0;
		this.envelope = 0;
		this.triggered = false;
		this.state = {
			loadProgress: 0,
			audioData: new Uint8Array(0),
			activeIndex: 3,
			offset: 0,
			octave: 3,
			root: 0,
			sourceBuffer: null,
			sourceStart: 0,
			sourceEnd: 1,
			clipName: 'no clip loaded',
		};

		this.envelopeParams = {
			attack: 0.02, // seconds until hitting 1.0
			decay: 0.5, // seconds until hitting sustain value
			sustain: 0.5, // sustain value
			release: 2.5, // seconds until returning back to 0.0};
		};

		this.overtones = [1, 3, 5, 7];

		this.OTGain = [20 / 4, 13 / 4, 5 / 4, 2 / 4];

		this.HPGain = 0;

		this.Q = 5000;

		this.echoParams = {
			MIX: 0.2,
			FDBK: 0.2,
			TIME: 0.5,
		};

		this.postFilterParams = {
			LP: {
				frequency: 20000,
				Q: 0,
				gain: 0,
			},
			HP: {
				frequency: 20,
				Q: 0,
				gain: 0,
			},
		};

		this.context = 0;

		this.looperState = 'CLEAR';

		this.clips = [
			{ url: 'beach.mp3', name: 'Ocean beach' },
			{ url: 'white_noise.wav', name: 'White noise' },
			{ url: 'rain.wav', name: 'Heavy rain' },
			{ url: 'fuelpumpA.mp3', name: 'fuel pump A' },
		];
	}

	setEnvelope = (key, value) => {
		this.envelopeParams[key] = value;
		this.choir.updateEnvelope(this.envelopeParams);
	};

	setQ = v => {
		this.choir.setQ(v);
		this.Q = v;
	};

	setNote = midiNumber => {
		this.choir.setNote(midiNumber);
	};

	stopNote = midiNumber => {
		this.choir.stopNote(midiNumber);
	};

	modulateNote = (midiNumber, value) => {
		this.choir.modulateNote(midiNumber, value);
	};

	setOTGain = (idx, value) => {
		this.OTGain[idx] = value;
		this.choir.updateOTGain(idx, value);
	};

	setOffness = value => {
		this.choir.offness = value;
	};

	setHPGain = value => {
		this.HPGain = value;
		this.choir.updateHPGain(value);
	};

	changeOffset = delta => {
		this.choir.stopAllNotes();
		this.setState({ offset: Math.min(Math.max(this.state.offset + delta, -7), 7) });
	};

	changeOctave = delta => {
		this.choir.stopAllNotes();
		this.setState({ octave: Math.min(Math.max(1, this.state.octave + delta), 5) });
	};

	setEchoParam = (key, value) => {
		this.echoParams[key] = value;
		this.echo.setParam(key, value);
	};

	changeRoot = delta => {
		this.choir.stopAllNotes();
		this.setState({ root: Math.min(Math.max(1, this.state.root + delta), 12) });
	};

	tick = () => {
		this.analyser.getByteFrequencyData(this.dataArray);
		this.setState({ audioData: this.dataArray });
		this.rafId = requestAnimationFrame(this.tick);
	};

	setPostFilterParam = (type, param, value) => {
		this.postFilter.setParam(type, param, value);
	};

	startLoopRec = () => {
		this.looperState = this.looper.startRec();
	};

	stopLoopRec = () => {
		this.looperState = this.looper.stopRec();
	};

	clearLoop = () => {
		this.looperState = this.looper.flush();
	};

	setSourceBuffer = b => {
		this.setState({ sourceBuffer: b });
	};

	setClipName = n => {
		this.setState({ clipName: n });
	};

	setSourceSound = url => {
		this.sourceLooper.loadSound(url, (progress, buffer) => {
			this.setState({ loadProgress: progress });

			if (buffer) {
				this.setSourceBuffer(buffer);
				this.setSourceStart(0);
				this.setSourceEnd(1);
			}
		});
	};

	setSourceStart = startRatio => {
		var delta = this.state.sourceEnd - this.state.sourceStart;
		startRatio = Math.min(Math.max(0, startRatio), 0.99);
		if (startRatio < this.state.sourceEnd) {
			this.setState({ sourceStart: startRatio }, this.sourceLooper.setLoopStart(startRatio));
		} else {
			this.setSourceStart(this.state.sourceEnd - 0.01);
		}
		this.setSourceEnd(startRatio + delta);
	};

	setSourceEnd = endRatio => {
		endRatio = Math.min(Math.max(0.01, endRatio), 1);
		if (endRatio > this.state.sourceStart) {
			this.setState({ sourceEnd: endRatio }, this.sourceLooper.setLoopEnd(endRatio));
		} else {
			this.setSourceEnd(this.state.sourceStart + 0.01);
		}
	};

	//TODO Order this nicely.

	componentDidMount() {
		// var context = new (window.AudioContext || window.webkitAudioContext)();
		this.context = new AudioContext();

		let masterNode = this.context.createGain();
		let outNode = this.context.createGain();
		let sourceGain = this.context.createGain();
		this.analyser = this.context.createAnalyser();
		this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);
		this.echo = new EchoNode(this.context);
		this.postFilter = new PostFilter(this.context);
		this.sourceLooper = new SourceLooper(this.context, sourceGain);
		this.looper = new Looper(this.context);

		this.choir = new Choir(sourceGain, this.context, outNode, this.envelopeParams, this.overtones);

		Object.keys(this.echoParams).forEach(k => this.setEchoParam(k, this.echoParams[k]));
		outNode.gain.setValueAtTime(5, this.context.currentTime);
		this.setSourceSound(this.clips[0].url);
		this.setQ(this.Q);
		this.OTGain.forEach((g, idx) => this.setOTGain(idx, g));
		this.setHPGain(this.HPGain);
		Object.keys(this.postFilterParams).forEach(k0 =>
			Object.keys(this.postFilterParams[k0]).forEach(k1 =>
				this.setPostFilterParam(k0, k1, this.postFilterParams[k0][k1])
			)
		);

		masterNode.connect(this.context.destination);
		this.postFilter.connect(this.looper.input);
		this.postFilter.connect(masterNode);
		this.looper.connect(masterNode);
		this.echo.connect(this.postFilter.input);
		outNode.connect(this.echo.input);
		masterNode.connect(this.analyser);

		//connect it to the destination so you can hear it.

		this.rafId = requestAnimationFrame(this.tick);
	}

	render() {
		const carouselItemStyle = { width: '100%', height: (37 / 100) * window.innerHeight };
		return (
			<React.Fragment>
				<div
					style={{
						height: '100%',
						width: '96%',
						margin: 'auto',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-evenly',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							width: '100%',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}
					>
						{['CTR', 'SRC', 'CRP', 'OVT', 'ENV', 'DLY', 'FLT', 'LPR', 'KB+'].map((name, idx) => (
							<div
								key={idx}
								style={{
									flexGrow: 1,
									background: this.state.activeIndex == idx ? COLOR_B : 'transparent',
									color: this.state.activeIndex == idx ? BACKGROUND_COLOR : COLOR_B,
									textAlign: 'center',
								}}
								onClick={() => this.setState({ activeIndex: idx })}
							>
								{name}
							</div>
						))}
					</div>
					<div style={{ width: '100%' }}>
						<Carousel
							activeIndex={this.state.activeIndex}
							slide={true}
							interval={null}
							controls={false}
							indicators={false}
						>
							<Carousel.Item>
								<div style={carouselItemStyle}>
									<KeyConfigView
										octave={this.state.octave}
										offset={this.state.offset}
										changeOctave={this.changeOctave}
										changeOffset={this.changeOffset}
										root={this.state.root}
										changeRoot={this.changeRoot}
									/>
								</div>
							</Carousel.Item>
							<Carousel.Item>
								<RemoveScroll>
									<div style={carouselItemStyle}>
										<SourceView
											setClipName={this.setClipName}
											clips={this.clips}
											setUrl={this.setSourceSound}
											loadProgress={this.state.loadProgress}
										/>
									</div>
								</RemoveScroll>
							</Carousel.Item>
							<Carousel.Item>
								<div style={carouselItemStyle}>
									<SourceLoopView
										clipName={this.state.clipName}
										clips={this.clips}
										setUrl={this.setSourceSound}
										buffer={this.state.sourceBuffer}
										setSourceStart={this.setSourceStart}
										setSourceEnd={this.setSourceEnd}
										setSourceOffset={this.setSourceOffset}
										sourceStart={this.state.sourceStart}
										sourceEnd={this.state.sourceEnd}
										loadProgress={this.state.loadProgress}
									/>
								</div>
							</Carousel.Item>
							<Carousel.Item>
								<div style={carouselItemStyle}>
									<OTView
										Q={this.Q}
										overtones={this.overtones}
										setOTGain={this.setOTGain}
										OTGain={this.OTGain}
										HPGain={this.HPGain}
										setHPGain={this.setHPGain}
										setOffness={this.setOffness}
									/>
								</div>
							</Carousel.Item>
							<Carousel.Item>
								<div style={carouselItemStyle}>
									<ADSRView width={width} setEnv={this.setEnvelope} envParams={this.envelopeParams} />
								</div>
							</Carousel.Item>
							<Carousel.Item>
								<div style={carouselItemStyle}>
									<EchoView setParam={this.setEchoParam} params={this.echoParams} />
								</div>
							</Carousel.Item>
							<Carousel.Item>
								<div style={carouselItemStyle}>
									<FilterView
										audioData={this.state.audioData}
										setParam={this.setPostFilterParam}
										params={this.postFilterParams}
									/>
								</div>
							</Carousel.Item>
							<Carousel.Item>
								<div style={carouselItemStyle}>
									<LooperView
										clearLoop={this.clearLoop}
										startLoopRec={this.startLoopRec}
										stopLoopRec={this.stopLoopRec}
										status={this.looperState}
									/>
								</div>
							</Carousel.Item>
							<Carousel.Item>
								<div style={{ ...carouselItemStyle }}>
									<div
										style={{
											height: '20%',
											width: '100%',
											opacity: this.state.loadProgress < 1 ? 0.5 : 1,
											overflow: 'visible',
										}}
									/>
									<div style={{ height: '80%', marginBottom: '0%' }}>
										<Keyboard
											releaseTime={this.envelopeParams.release}
											octave={this.state.octave}
											offset={this.state.offset}
											setNote={this.setNote}
											root={this.state.root}
											stopNote={this.stopNote}
											isLoading={!this.state.loadProgress}
											modulateNote={this.modulateNote}
											baseNotes={[24, 20, 16]}
										/>
									</div>
								</div>
							</Carousel.Item>
						</Carousel>
					</div>

					<div
						style={{
							height: '41%',
							width: '100%',
							opacity: this.state.loadProgress < 1 ? 0.5 : 1,
						}}
					>
						<Keyboard
							releaseTime={this.envelopeParams.release}
							octave={this.state.octave}
							offset={this.state.offset}
							setNote={this.setNote}
							root={this.state.root}
							stopNote={this.stopNote}
							loadProgress={this.state.loadProgress}
							modulateNote={this.modulateNote}
							baseNotes={[12, 8, 4, 0]}
						/>
					</div>
					<div style={{ height: '10%', width: '100%' }}>
						<TouchSlider
							defaultValue={this.Q}
							setValue={v => this.setQ(Math.pow(1.0017, v))}
							min={0}
							max={5000}
							label={<h2>Q</h2>}
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default Synth;
